import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({ name, color = "black" }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundColor: "white",
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <p
          style={{
            textAlign: "center",
            paddingBlockStart: "2em",
          }}
        >
          <b>Select a Booking Type</b>
        </p>
        <div
          style={{
            width: "90%",
            height: "80px",
            borderTop: `5px solid ${color}`,
            borderLeft: "2px solid lightgray",
            borderBottom: "2px solid lightgray",
            borderRight: "2px solid lightgray",
            borderRadius: "5px",
            marginLeft: "8px",
            textAlign: "center",
            marginTop: "30px",
          }}
        >
          <p
            style={{
              margin: "0px",
              marginTop: "3px",
              height: name ? "fit-content" : "20px",
            }}
          >
            {name}
          </p>
          <p
            style={{
              margin: "0px",
            }}
          >
            Booking Type Name
          </p>
          <p
            style={{
              margin: "0px",
            }}
          >
            Duration - Price
          </p>
        </div>
      </div>
    </PhoneArea>
  )
}

export default Preview
